export default __webpack_public_path__ + "static/media/19 Track 19.2fe680b7.mp3";